import { useForm as useFormHook } from "hooks";
import {
    FormField,
    type PreApplicationForm,
    type PreApplication
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = (initialValues: Partial<PreApplication> = {}): PreApplication => ({
    [FormField.BusinessActivity]: null,
    [FormField.ProductService]: null,
    [FormField.Email]: '',
    [FormField.Password]: '',
    [FormField.ConfirmPassword]: '',
    [FormField.ProductServiceOther]: '',
    ...initialValues
});

export const useForm = (preApplicationForm: PreApplicationForm) =>
    useFormHook({
        isInitialValid: false,
        ...preApplicationForm,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
